export default __webpack_public_path__ + "cards/img/messengers/telegram-rounded.svg";